// Types for GTM events
export interface Route {
  meta?: {
    title?: string;
  };
  fullPath?: string;
}

export interface UserData {
  userId?: string;
  accountProvider?: string; // "Facebook" | "Google" | "Apple"
  email?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  createdDateUtc?: string;
}

export interface ScrollData {
  threshold: number;
  path: string;
  title: string;
}

export interface SearchData extends Record<string, unknown> {
  search_term: string;
}

export interface MenuClickData extends Record<string, unknown> {
  text: string;
}

export interface BurgerMenuToggleData extends Record<string, unknown> {
  state: string;
}

export interface FeedClickData extends Record<string, unknown> {
  feed_name: string;
}

export interface CreatePostData extends Record<string, unknown> {
  post_name: string;
  link_list?: string;
  tag_list?: string;
}

export interface FollowActiveData extends Record<string, unknown> {
  active_name: string;
  active_category: string;
}

export interface FollowInvestorData extends Record<string, unknown> {
  investor_name: string;
  investor_type: string;
}

export interface SendMessageInvestorData extends Record<string, unknown> {
  sender_name: string;
  receptor_name: string;
}

export interface ClickAlertData extends Record<string, unknown> {
  active_name: string;
  active_category: string;
}

export interface ClickTopPortfoliosData extends Record<string, unknown> {
  name: string;
  position: string;
}

export interface PortfolioCreationData extends Record<string, unknown> {
  portfolio_name: string;
  portfolio_creation_date: string; // format: "DD/MM/YYYY"
  portfolio_main_currency: string; // e.g. "EUR"
  portfolio_privacy_type: string; // e.g. "Privé"
  // TODO: Discuss if we add cash info in the future
  // portfolio_money_volume: number;
}

export interface TransactionCompletedData extends Record<string, unknown> {
  transaction_type: string; // e.g. "Assets"
  operation_type: string; // e.g. "Buy"
  active_name: string; // e.g. "Paypal"
  currency: string; // e.g. "EUR"
  // TODO: Discuss if we add cash info in the future
  // action_quantity: number;     // e.g. 3
  // transaction_total: string;  // e.g. "150.00"
}

export interface InteractionArticleData extends Record<string, unknown> {
  post_id: string;
  // Only relevant for news posts, for which it'll be the news title
  post_name: string;
  // Not too clear about what this is supposed to represent
  event_category: string;
  event_action: PostInteractionType;
  post_author?: string;
  post_author_id?: string;
  post_interactor?: string;
  post_interactor_id?: string;
}

export enum PostInteractionType {
  Like = 'Like',
  Unlike = 'Unlike',
  Repost = 'Repost',
  Share = 'Share',
  Comment = 'Comment',
  Save = 'Saved to Favorites',
  Unsave = 'Removed from Favorites',
}

export interface PostImpressionData extends Record<string, unknown> {
  post_id: string;
  post_author: string;
  post_author_id: string;
}

export const PostImpressionThreshholds = {
  // 90% of the post appears on screen
  VisibilityThreshold: 0.9,
  // Post visible for 1s
  // Due to implementation details, this turned out as "post still visible after 1s"
  // So scrolling the post out, then back in before the timer ends will still fire the event
  VisibilityTimerDuration: 600,
};

export enum PortfolioInteractionType {
  Favorite = 'Favorite click',
  Comment = 'Comment click',
  Repost = 'Repost click',
  Message = 'Message click',
  Share = 'Share click',
}

export interface PortfolioInteractionData extends Record<string, unknown> {
  event_category: string;
  event_action: PortfolioInteractionType;
  portfolio_name: string;
}

export interface GtmPush {
  push: (data: Record<string, unknown>) => void;
}

export interface InteractionEventData extends Record<string, unknown> {
  event_category: string;
  event_action: string;
  post_name: string;
}

export interface OnboardingNextStepData extends Record<string, unknown> {
  onborading_step: string;
  step_name: string;
  selected_option: string;
}
export interface LoginData extends Record<string, unknown> {
  user_email: string;
  user_first_name: string;
  login_method: string;
  user_id: string;
}
export interface RegisterData extends Record<string, unknown> {
  user_email: string;
  user_first_name: string;
  user_id: string;
  signup_method: string;
}
